import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Import images
import collegeImage from "../../Assets/Projects/college.jpeg";
import Fastbanking from "../../Assets/Projects/GlobalSmart Logo 1.svg";
import humanityImage from "../../Assets/Projects/balance_humanity_main_logo.png";
import globalJuniorImage from "./../../Assets/Projects/junior.svg";
import biznexImage from "./../../Assets/globalbiznex.png"

function Projects() {
  // Animation variants for framer-motion
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
        >
          <h1 className="project-heading">
            My Recent <strong className="purple">Works</strong>
          </h1>
          <p style={{ color: "white" }}>
            Here are a few projects I've worked on recently.
          </p>

          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            {/* Global Smart Plus (Major Project) */}
            <Col md={4} className="project-card">
              <motion.div variants={cardVariants}>
                <ProjectCard
                  imgPath={Fastbanking}
                  isBlog={false}
                  title="Global Smart Plus"
                  description="Global Smart Plus is a secure omni-channel banking platform offering seamless web and mobile banking, built with microservices, gRPC, Node.js, Docker, and Kubernetes"
                  demoLink="https://globalonline.gibl.com.np/"
                  date="2021 - Present"
                  isMajor={true}
                />
              </motion.div>
            </Col>

            {/* Global Junior App */}
            <Col md={4} className="project-card">
              <motion.div variants={cardVariants}>
                <ProjectCard
                  imgPath={globalJuniorImage}
                  isBlog={false}
                  title="Global Junior App"
                  description="Global Junior App is a secure, microservices-based child banking platform built with gRPC, Node.js, Docker, and Kubernetes, offering parental controls, tasks, savings, and smart spending."
                  demoLink="https://www.globalimebank.com/products/digital-payments/global-junior/"
                  date="2023 - 2025"
                  isMajor={true}
                />
              </motion.div>
            </Col>


           {/* Global Biznex Corporate Internet Banking */}
                      <Col md={4} className="project-card">
            <motion.div variants={cardVariants}>
              <ProjectCard
                imgPath={biznexImage}
                isBlog={false}
                title="Global Biznex Corporate Internet Banking"
                description="Global Biznex is a secure, microservices-based corporate banking platform built with gRPC, Node.js, Docker, and Kubernetes, offering fund transfers, bulk payments, and access control."
                demoLink="https://biznex.gibl.com.np/login"
                date="2023 - 2025"
                isMajor={true}
              />
            </motion.div>
          </Col>

            

            {/* Balance Humanity */}
            <Col md={4} className="project-card">
              <motion.div variants={cardVariants}>
                <ProjectCard
                  imgPath={humanityImage}
                  isBlog={false}
                  title="Balance Humanity"
                  description="A fintech platform for targeted aid distribution in disaster-prone areas, built with Node.js, React, Vite, Express, Redis, MinIO, Docker, and Azure. Implemented secure authentication, KYC, and imePay API for interbank transfers."
                  demoLink="https://github.com/avhishek-49/Balance-Humanity.git"
                  date="2022 - 2023"
                  isCollegeProject = {true}

                />
              </motion.div>
            </Col>

            {/* School College Management */}
            <Col md={4} className="project-card">
              <motion.div variants={cardVariants}>
                <ProjectCard
                  imgPath={collegeImage}
                  isBlog={false}
                  title="School College Management"
                  description="A comprehensive college management system with role-based access control. Built with Node.js and React.js, it streamlines academic and administrative tasks for educational institutions."
                  demoLink="https://github.com/avhishek-49/college-management-project"
                  date="2021 - 2022"
                  isCollegeProject = {true}

                />
              </motion.div>
            </Col>
          </Row>
        </motion.div>
      </Container>
    </Container>
  );
}

export default Projects;